import { MenuItem, Select } from "@mui/material";
import { getMonth, getYear } from "date-fns";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";

export default function YearMonthDropDown({ defaultYear = null, defaultMonth = null, onChange }) {
  const [year, setYear] = useState(getYear(Date.now()));
  const [month, setMonth] = useState(getMonth(Date.now()) + 1);

  useEffect(() => {
    if (defaultYear) setYear(defaultYear);
    if (defaultMonth) setMonth(defaultMonth);
  }, [defaultYear, defaultMonth]);

  const years = [2024, 2025];
  const months = Array.from({ length: 12 }, (_, i) => i + 1);

  const handleChange = (event) => {
    const value = event.target.value;
    const _year = value > 2000 ? value : year;
    const _month = value < 2000 ? value : month;
    setYear(_year);
    setMonth(_month);
    onChange({ year: _year, month: _month });
  };

  return (
    <div style={{ display: "flex", gap: 8 }}>
      <Select
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        value={year || 2024}
        onChange={handleChange}>
        {years.map((year) => (
          <MenuItem key={year} value={year}>
            {year}
          </MenuItem>
        ))}
      </Select>
      <Select
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        value={month || 1}
        onChange={handleChange}>
        {months.map((month) => (
          <MenuItem key={month} value={month}>
            {new Date(2024, month - 1).toLocaleString("fi", { month: "long" })}
          </MenuItem>
        ))}
      </Select>
    </div>
  );
}

YearMonthDropDown.propTypes = {
  onChange: PropTypes.func,
  defaultYear: PropTypes.number,
  defaultMonth: PropTypes.number,
};

// sample usage
// import { useState } from "react";
// import YearMonthDropDown from "./YearMonthDropDown";
// <YearMonthDropDown value="2024-01" onChange={(value) => console.log(value)} defaultYear={2024} defaultMonth={1} />
